import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import ViewWidget from "../euvComparison/ViewWidget";
import ObsWidget from "./ObsWidget";
import cloneDeep from "lodash/cloneDeep";

const SRC_ID_DEFAULTS = {
  83: {
    slice_widget: {vignette_function: 'coronagraph', radial_power: -2, log_transform: false, color: 'kcor'},
    view_widget: {symmetric: false, zaxis_min: 0, zaxis_max: null},
    obs_widget: {distinct_view: false}
  },
}

const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  view_widget: {},
  obs_widget: {}
}

const DEFAULTS = {
  sim_widget: {
    domain: 'cor',
    time_of_interest: null,
  },
  obs_widget: {
    src_id: 83,
    quality_check: false,
    distinct_view: false,
    radial_power: -2,
    vignette_function: 'coronagraph',
    log_transform: false,
    zaxis_min: 0.,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
  },
  slice_widget: {
    occult_color: '#FFFFFF',
    radial_power: -2,
    vignette_function: 'coronagraph',
    log_transform: true,
    color: 'kcor'
  },
  view_widget: {
    zaxis_min: 0.,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
    grid: null,
  },
}

const flagTriggers = {
  obs_widget: {src_id: true}, sim_widget: {time_of_interest: true}
}

const flagDependencies = {
  obs_widget: {src_id: true}, sim_widget: {time_of_interest: true}
}

const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = null;
  switch (k) {
    case 'time_of_interest':
      modifiedParams = cloneDeep(SRC_ID_DEFAULTS[dependencies.obs_widget.src_id])
      modifiedParams['sim_widget'] = {}
      break;
    case 'src_id':
      modifiedParams = cloneDeep(SRC_ID_DEFAULTS[v])
      break;
    default:
      modifiedParams = cloneDeep(PARAM_SCHEMA);
      break;
  }
  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const Coronagraphs = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='coronagraphs'
        toolName='Coronagraphs'
        flagTriggers={flagTriggers}
        flagDeps={flagDependencies}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        viewWidget={ViewWidget}
        obsWidget={ObsWidget}
      />
    </>

  )
}

export default Coronagraphs;